(function () {
  // ── Config ──────────────────────────────────────────────────────────────
  var MOBILE_SLIDES = [
    {
      image: 'https://cdn.shopify.com/s/files/1/1134/2032/files/New_44_2025_SQUARE_bigger2_50.jpg?v=1779787198',
      buttonText: 'Browse Hot Chocolate',
      buttonUrl: 'https://harryshotchocolate.co.uk/collections/hot-chocolate-wholesale?coffeeshops'
    },
    {
      image: 'https://cdn.shopify.com/s/files/1/1134/2032/files/carrot_homepage_image50.jpg?v=1779787199',
      buttonText: 'Browse Bakery',
      buttonUrl: 'https://harryshotchocolate.co.uk/collections/food-items?coffeeshops'
    }
  ];

  var DESKTOP_SLIDES = [
    {
      image: 'https://cdn.shopify.com/s/files/1/1134/2032/files/wholesale_banner_2_50_new_code.jpg?v=1791317032'
    },
    {
      image: 'https://cdn.shopify.com/s/files/1/1134/2032/files/carrot_homepage_desktop_image50.jpg?v=1791317086'
    }
  ];

  var INTERVAL_MS    = 5000;
  var TRANSITION_MS  = 600;
  var SWIPE_THRESHOLD = 50;
  var BANNER_ID  = 'Banner-template--29731435217270__image_banner';
  var MOBILE_ID  = 'harry-mobile-rotator-welcome';
  var DESKTOP_ID = 'harry-desktop-rotator-welcome';
  // ────────────────────────────────────────────────────────────────────────

  function isMobile() {
    return window.innerWidth <= 440;
  }

  function preloadFirstImages() {
    var src = isMobile() ? MOBILE_SLIDES[0].image : DESKTOP_SLIDES[0].image;
    var link = document.createElement('link');
    link.rel  = 'preload';
    link.as   = 'image';
    link.href = src;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);
  }

  function addSwipeSupport(track, getCurrent, setCurrent, total, onSwipe) {
    var touchStartX = 0;
    var touchStartY = 0;
    var isDragging  = false;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isDragging  = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dy) > Math.abs(dx)) return;
      onSwipe(dx < 0 ? 'next' : 'prev');
    }, { passive: true });
  }

  // ── Mobile rotator ───────────────────────────────────────────────────────
  function buildMobileRotator() {
    if (document.getElementById(MOBILE_ID)) return;
    var banner = document.getElementById(BANNER_ID);
    if (!banner) return;

    var rotator = document.createElement('div');
    rotator.id  = MOBILE_ID;

    var track = document.createElement('div');
    track.id  = MOBILE_ID + '-track';

    MOBILE_SLIDES.forEach(function (slide, index) {
      var img  = document.createElement('img');
      img.src  = slide.image;
      img.alt  = slide.buttonText;
      if (index === 0) { img.setAttribute('fetchpriority', 'high'); img.loading = 'eager'; }
      else { img.loading = 'lazy'; }
      track.appendChild(img);
    });

    // Clone first slide for seamless loop
    var clone  = document.createElement('img');
    clone.src  = MOBILE_SLIDES[0].image;
    clone.alt  = MOBILE_SLIDES[0].buttonText;
    clone.loading = 'lazy';
    track.appendChild(clone);

    var btn    = document.createElement('a');
    btn.id     = MOBILE_ID + '-btn';
    btn.href   = MOBILE_SLIDES[0].buttonUrl;
    btn.textContent = MOBILE_SLIDES[0].buttonText;

    rotator.appendChild(track);
    rotator.appendChild(btn);
    banner.appendChild(rotator);
  }

  function startMobileRotation() {
    var current = 0;
    var total   = MOBILE_SLIDES.length;
    var track   = document.getElementById(MOBILE_ID + '-track');
    var btn     = document.getElementById(MOBILE_ID + '-btn');
    if (!track || !btn) return;

    function goTo(next) {
      track.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
      track.style.transform  = 'translateX(-' + (next * 100) + '%)';
      var realNext = ((next % total) + total) % total;
      btn.style.opacity = '0';
      setTimeout(function () {
        btn.href        = MOBILE_SLIDES[realNext].buttonUrl;
        btn.textContent = MOBILE_SLIDES[realNext].buttonText;
        btn.style.opacity = '1';
      }, TRANSITION_MS / 2);
      current = next;
      if (next >= total) {
        setTimeout(function () {
          track.style.transition = 'none';
          track.style.transform  = 'translateX(0%)';
          current = 0;
        }, TRANSITION_MS + 50);
      }
    }

    var timer = setInterval(function () { goTo(current + 1); }, INTERVAL_MS);

    addSwipeSupport(track, function () { return current; }, function (v) { current = v; }, total, function (dir) {
      clearInterval(timer);
      if (dir === 'next') {
        goTo(current + 1);
      } else {
        var prev = current <= 0 ? total - 1 : current - 1;
        track.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
        track.style.transform  = 'translateX(-' + (prev * 100) + '%)';
        var realPrev = ((prev % total) + total) % total;
        btn.style.opacity = '0';
        setTimeout(function () {
          btn.href        = MOBILE_SLIDES[realPrev].buttonUrl;
          btn.textContent = MOBILE_SLIDES[realPrev].buttonText;
          btn.style.opacity = '1';
        }, TRANSITION_MS / 2);
        current = prev;
      }
      timer = setInterval(function () { goTo(current + 1); }, INTERVAL_MS);
    });
  }

  // ── Desktop rotator ──────────────────────────────────────────────────────
  function buildDesktopRotator() {
    if (document.getElementById(DESKTOP_ID)) return;
    var banner = document.getElementById(BANNER_ID);
    if (!banner) return;

    var rotator = document.createElement('div');
    rotator.id  = DESKTOP_ID;

    var track = document.createElement('div');
    track.id  = DESKTOP_ID + '-track';

    DESKTOP_SLIDES.forEach(function (slide, index) {
      var img  = document.createElement('img');
      img.src  = slide.image;
      img.alt  = '';
      if (index === 0) { img.setAttribute('fetchpriority', 'high'); img.loading = 'eager'; }
      else { img.loading = 'lazy'; }
      track.appendChild(img);
    });

    // Clone first slide for seamless loop
    var clone  = document.createElement('img');
    clone.src  = DESKTOP_SLIDES[0].image;
    clone.loading = 'lazy';
    track.appendChild(clone);

    rotator.appendChild(track);
    banner.appendChild(rotator);
  }

  function startDesktopRotation() {
    var current = 0;
    var total   = DESKTOP_SLIDES.length;
    var track   = document.getElementById(DESKTOP_ID + '-track');
    if (!track) return;

    function goToDesktop(next) {
      track.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
      track.style.transform  = 'translateX(-' + (next * 100) + '%)';
      current = next;
      if (next >= total) {
        setTimeout(function () {
          track.style.transition = 'none';
          track.style.transform  = 'translateX(0%)';
          current = 0;
        }, TRANSITION_MS + 50);
      }
    }

    var timer = setInterval(function () { goToDesktop(current + 1); }, INTERVAL_MS);

    addSwipeSupport(track, function () { return current; }, function (v) { current = v; }, total, function (dir) {
      clearInterval(timer);
      if (dir === 'next') {
        goToDesktop(current + 1);
      } else {
        var prev = current <= 0 ? total - 1 : current - 1;
        track.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
        track.style.transform  = 'translateX(-' + (prev * 100) + '%)';
        current = prev;
      }
      timer = setInterval(function () { goToDesktop(current + 1); }, INTERVAL_MS);
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    preloadFirstImages();
    if (isMobile()) {
      buildMobileRotator();
      startMobileRotation();
    } else {
      buildDesktopRotator();
      startDesktopRotation();
    }
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var mob = document.getElementById(MOBILE_ID);
      var dsk = document.getElementById(DESKTOP_ID);
      if (mob) mob.style.display = isMobile() ? 'block' : 'none';
      if (dsk) dsk.style.display = isMobile() ? 'none'  : 'block';
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();